import React, { useState } from "react";
import TreeChildren from "./TreeChildren";
import { getNodeValue } from "../utils";

function TreeEdgesEnclosure(props) {
  const userSub = props.userSub;
  const settings = props.settings;
  const parentId = props.parentId;

  let nodeState = getNodeValue(settings.treeStates, parentId);
  let expanded = !nodeState ? "true" : "false";

  return (
    <div>
      <div className={`tree-items-${expanded}`}>
        <TreeChildren userSub={userSub} edge={props.edge} />
      </div>
    </div>
  );
}

export default TreeEdgesEnclosure;
